import { useEffect, useState } from 'react'
import { checkFormValidity, validateForm } from '../../FullName/validate'
import { NameFormErrors, NameFormTouched } from '../../FullName/types'
import { validateDate } from '../../Birthday/validate'
import { AgeCaluculation } from '../../Birthday/AgeCaluculation'
import { DATE_CONSTANTS } from '../../../../../constants/progressBanner'
import { validatePassword } from '../../LoginInformation/validate'

interface UseBasicInformationValidationProps {
    lastName: string
    firstName: string
    lastNameKana: string
    firstNameKana: string
    year: string
    month: string
    password: string
}

export const useBasicInformationValidation = ({
    lastName,
    firstName,
    lastNameKana,
    firstNameKana,
    year,
    month,
    password,
}: UseBasicInformationValidationProps) => {
    const [nameTouched, setNameTouched] = useState<NameFormTouched>({
        lastName: false,
        firstName: false,
        lastNameKana: false,
        firstNameKana: false,
    })

    const [nameErrors, setNameErrors] = useState<NameFormErrors>({
        lastName: '',
        firstName: '',
        lastNameKana: '',
        firstNameKana: '',
    })

    const [hasInteractedBirthday, setHasInteractedBirthday] = useState<boolean>(false)
    const currentDate = new Date()
        .toISOString()
        .slice(0, DATE_CONSTANTS.DATE_SLICE_END)
    const [birthdayValid, setBirthdayValid] = useState<boolean>(false)
    const [birthdayValidateMessage, setBirthdayValidateMessage] = useState<string>('')
    const [age, setAge] = useState<number | null>(null)

    const [passwordTouched, setPasswordTouched] = useState({ password: false })
    const [passwordErrors, setPasswordErrors] = useState({ password: '' })

    useEffect(() => {
        const formValues = {
            lastName,
            firstName,
            lastNameKana,
            firstNameKana,
        }
        const newErrors = validateForm(formValues, nameTouched)
        setNameErrors(newErrors)
    }, [lastName, firstName, lastNameKana, firstNameKana, nameTouched])

    useEffect(() => {
        if (hasInteractedBirthday) {
            setBirthdayValid(
                validateDate(year, month, currentDate, setBirthdayValidateMessage)
            )
        } else if (year !== '' || month !== '') {
            setHasInteractedBirthday(true)
        }

        if (year && month && currentDate) {
            const calculatedAge = AgeCaluculation({
                year,
                month,
                currentDate,
            })
            setAge(calculatedAge)
        }
    }, [month, year, hasInteractedBirthday, currentDate])

    useEffect(() => {
        const passwordError = validatePassword(password, passwordTouched.password)
        setPasswordErrors({ password: passwordError || '' })
    }, [password, passwordTouched])

    const isFormValid =
        checkFormValidity({ lastName, firstName, lastNameKana, firstNameKana }) &&
        birthdayValid &&
        password.length >= 8 &&
        !passwordErrors.password &&
        password !== ''

    return {
        nameTouched,
        setNameTouched,
        nameErrors,
        hasInteractedBirthday,
        setHasInteractedBirthday,
        birthdayValid,
        birthdayValidateMessage,
        age,
        passwordTouched,
        setPasswordTouched,
        passwordErrors,
        isFormValid,
    }
}

